import { LogBox, Platform } from 'react-native';

import AppNavigator from './mobile/navigation/AppNavigator';
import LinkingConfig from './mobile/navigation/LinkingConfig';
import { MessagingProps } from './Types';
import { NavigationContainer } from '@react-navigation/native';
import React from 'react';

if (Platform.OS !== 'web') {
  LogBox.ignoreAllLogs(true);
}

const debug = require('debug')('omni:messaging:native:index');

// Even though this is called Messaging.native.tsx,
// it is only used on the web platform
// TODO: rename this file.

export default function Messaging(props: MessagingProps) {
  return (
    <NavigationContainer
      // @ts-ignore
      linking={LinkingConfig}
      documentTitle={{ enabled: false }}
    >
      {/* @ts-ignore */}
      <AppNavigator screenProps={props} />
    </NavigationContainer>
  );
}
